import { render } from "./LinkList.vue?vue&type=template&id=beb1bf76"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__